<template>
  <li class="flex justify-between px-4 py-4 notification hover:shadow-inner" :class="{ 'cursor-pointer': clickable, 'empty-state-gray': notification.read, 'bg-white': !notification.read }" @click="clicked">
    <div class="flex items-start">
      <feather-icon :class="{'text-dark': !notification.read}" :icon="icon" :svgClasses="[`text-${category}`, 'stroke-current mr-1 h-6 w-6']"></feather-icon>
      <div class="mx-2">
        <span class="font-medium block notification-title flex items-center" :class="{ 'font-bold': !notification.read, 'line-through': notification.read, 'text-black': !notification.read, }" ><span :class="`text-${category}`">{{ title }}
        </span><feather-icon icon="CheckIcon" v-if="notification.read" class="w-4 text-success"></feather-icon></span>
        <small>{{ message }}</small>
      </div>
    </div>

    <small class="mt-1 whitespace-no-wrap"><vs-chip color="#0CF2AD" v-if="ai">AI</vs-chip></small>
  </li>
</template>

<!-- :class="[`text-${notification.category}`]" -->

<script>
import _ from 'lodash'

export default {
  components: {
  },
  props: ['notification'],
  data () {
    return {
      titles: {
        'HelloAndWelcome': 'your first steps',
        'FirstChapter': 'the beginning of your timeline',
        'Academy': 'first academy session',
        'WeeklyReview': 'reflect on last week',
        'DownloadApp': 'install improvee.io',
        'BackgroundPicker': 'customize the design',
        'InviteFriends': 'invite your friends',
        'MoodTracker': 'track your mood',
        'LifeBalance': 'review your life balance',
        'DiscoveryQuestion': 'answer your discovery question',
        'Journal': 'write down your thoughts',
        'GetInspiredRoutine': ' try a new routine',
        'EarnPassiveIncome': 'earn passive income',
        'AiCoaching': 'AI coaching',
        'SecondDay': 'achievement: action taker',
        'FourDayStreak' : 'achievement: 4 days streak',
        'AfterOneWeek' : 'achievement: weeklong mastery',
        'AfterOneMonth' : 'achievement: month of momentum',


      },
      icons: {
       'HelloAndWelcome': 'TargetIcon',
       'FirstChapter': 'SunriseIcon',
       'Academy': 'BookOpenIcon',
       'WeeklyReview': 'BookOpenIcon',
       'DownloadApp': 'DownloadIcon',
       'BackgroundPicker': 'ImageIcon',
       'InviteFriends': 'UsersIcon',
       'MoodTracker': 'SmileIcon',
       'LifeBalance': 'HexagonIcon',
       'DiscoveryQuestion': 'CoffeeIcon',
       'Journal': 'FeatherIcon',
       'GetInspiredRoutine': 'RotateCwIcon',
       'EarnPassiveIncome': 'DollarSignIcon',
       'AiTip': 'TerminalIcon',
       'AiCoaching': 'TerminalIcon',
       'SecondDay': 'AwardIcon',
        'FourDayStreak' : 'AwardIcon',
        'AfterOneWeek' : 'AwardIcon',
        'AfterOneMonth' : 'AwardIcon',

      },
      messages: {
        'HelloAndWelcome': 'let\'s get it started.',
        'FirstChapter': 'track progress to measure success.',
        'Academy': 'transform your life with improvee.io Academy.',
        'DownloadApp': 'add improvee.io to homescreen for quick access.',
        'WeeklyReview': ' review the highlights and lowlights.',
        'BackgroundPicker': 'under your profile picture → appearance settings.',
        'InviteFriends': 'inspire your friends to make changes in their lives.',
        'MoodTracker': 'identify triggers and patterns.',
        'LifeBalance': 'optimize your time and energy.',
        'DiscoveryQuestion': 'gain new perspectives.',
        'Journal': 'learn from your experiences.',
        'GetInspiredRoutine': 'life-changing routines can be quick and simple.',
        'EarnPassiveIncome': 'promote improvee.io and earn passive income with referrals.',
        'AiCoaching': 'receive personalized recommendations, suggestions, tips and guidance',
        'SecondDay': 'consistency is key to success',
        'FourDayStreak' : '4 days in a row is no coincidence, well done.',
        'AfterOneWeek' : 'exactly one week ago, you began. Congrats.',
        'AfterOneMonth' : 'it\'s been one month! Congrats, virtual high five👋',


      }
    }
  },
  watch: {
    'actionStillEnabled': {
      immediate: true,
      handler (newValue) {
        if (!newValue && !this.read) {
          this.markAsRead()
          // this.notifier.alreadyDone(this.icon, this.title)
        }
      }
    },
  },
  computed: {
    read () {
      return this.notification.read
    },
    pending () {
      return !this.read
    },
    clickable () {
      if (this.actionable) {
        return true
      } else {
        return this.pending
      }
    },
    actionName () {
      return this.notification.actionName
    },
    action () {
      return this.notification.action
    },
    actionable () {
      return this.actionStillEnabled && this.actionPresent
    },
    actionableButDone () {
      return !this.actionStillEnabled && this.actionPresent
    },
    actionStillEnabled () {
      if (this.actionName === 'HelloAndWelcome') {
        return !this.$store.getters.helloAndWelcomeEnded
      }

      if (this.actionName === 'FirstChapter') {
        return !this.$store.getters.firstChapter
      }

      if (this.actionName === 'Academy') {
        return !this.$store.getters.academyRequested
      }

      return true
    },
    actionPresent () {
      return this.notification.actionName
    },
    icon () {
      return this.icons[this.actionName]
    },
    title () {
      if (this.aiTip) {
        return this.notification.title
      }

      return this.titles[this.actionName]
    },
    category () {
    },
    message () {
      if (this.aiTip) {
        return this.notification.message
      }

      return this.messages[this.actionName]
    },
    ai () {
      return this.aiTip || this.actionName == 'AiCoaching'
    },
    aiTip () {
      name = (this.actionName || '').toLowerCase()

      return name == 'aitip'
    }
  },
  methods: {
    markAsRead () {
      this.$store.dispatch('UPDATE_NOTIFICATION', { notification: this.notification, updateFields: { read: true, readAt: new Date() } })
    },
    clicked () {
      if (!this.read) {
        this.markAsRead()
      }

      if (this.actionable) {
        if (this.actionName === 'HelloAndWelcome') {
          this.$store.dispatch('ADDITIONAL_USER_INFO', { helloAndWelcomeStarted: true, helloAndWelcomeStartedFromNotification: true })
          this.$store.commit('SET_SHOW_SETUP', true)
        }

        if (this.actionName === 'Academy') {
          this.$router.push({ name: 'academy', query: { startAcademy: true } }).catch(() => {})
        }

        const addJournalActions = [
          'MoodTracker',
          'LifeBalance',
          'DiscoveryQuestion',
          'Journal']

        if (_.includes(addJournalActions, this.actionName)) {
          this.$router.push({ name: 'journey', query: { journalAddEntry: true } }).catch(() => {})
        }

        if (this.actionName === 'WeeklyReview') {
          this.$router.push({ name: 'journey', query: { addReview: true } }).catch(() => {})
        }

        if (this.actionName === 'FirstChapter') {
          this.$router.push({ name: 'journey', query: { embraceJourney: true } }).catch(() => {})
        }

        if (this.actionName === 'GetInspiredRoutine') {
          this.$router.push({ name: 'planner', query: { initWithRoutineSidebarOpen: 'true', getInspiredFilter: 'true'  }}).catch(() => {})
        }

        if (this.actionName === 'DownloadApp') {
          this.$emit('showPopup', 'DownloadApp')
        }

        if (this.actionName === 'BackgroundPicker') {
          this.$emit('showPopup', 'BackgroundPicker')
        }

        if (this.actionName === 'InviteFriends') {
          this.$emit('showPopup', 'InviteFriends')
          this.$store.dispatch('ADDITIONAL_USER_INFO', { seenPopupInviteFriends: true })
        }

        if (this.actionName === 'EarnPassiveIncome') {
          this.$emit('showPopup', 'EarnPassiveIncome')
          this.$store.dispatch('ADDITIONAL_USER_INFO', { seenPopupEarnPassiveIncome: true })
        }

        if (this.actionName === 'AiCoaching') {
          this.$emit('showPopup', 'AiCoaching')
          this.$store.dispatch('ADDITIONAL_USER_INFO', { seenPopupAiCoaching: true })
        }

        if (this.actionName === 'SecondDay') {
          this.$emit('showPopup', 'SecondDay')
          this.$store.dispatch('ADDITIONAL_USER_INFO', { seenPopupSecondDay: true })
        }

        if (this.actionName === 'FourDayStreak') {
          this.$emit('showPopup', 'FourDayStreak')
          this.$store.dispatch('ADDITIONAL_USER_INFO', { seenPopupFourDayStreak: true })
        }

        if (this.actionName === 'AfterOneWeek') {
          this.$emit('showPopup', 'AfterOneWeek')
          this.$store.dispatch('ADDITIONAL_USER_INFO', { seenPopupAfterOneWeek: true })
        }

        if (this.actionName === 'AfterOneMonth') {
          this.$emit('showPopup', 'AfterOneMonth')
          this.$store.dispatch('ADDITIONAL_USER_INFO', { seenPopupAfterOneMonth: true })
        }
        if (this.aiTip) {
          this.$emit('showPopup', 'AiTip', this.notification)
          this.$store.dispatch('ADDITIONAL_USER_INFO', { seenPopupAiTip: true })
        }

        this.$emit('dropdownClose')
      } else if (this.actionableButDone) {

        this.$emit('dropdownClose')
      }
    }
  },

}

</script>



</style>
